module.exports = __webpack_public_path__ + "img/no-digital-collectibles.2ddc1f61.webp";